<template>
  <ai-chat
    mode="mcpResource"
    :data="data"
    :res-id="resId" />
</template>

<script>
import AiChat from '@Ai/sections/Chat'

export default {
  name: 'McpChat',
  components: {
    AiChat,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    resId: {
      type: String,
      required: true,
    },
  },
}
</script>
